import { useCallback } from 'react';
import { isIntegrationTestOn, loginSuccess } from '@lib/integrationDialog';
import { getNrUUID } from '@chegg/one-auth';
import { CallbackParams } from '@chegg/one-auth';

export function useOneAuthEvent(window: Window, customRedirect: string | URL, envUrl: string) {
  return useCallback(
    (params: CallbackParams) => {
      const { type } = params;
      switch (type) {
        case 'log':
          console.log('one-auth log event', params.payload);
          break;
        case 'auth': {
          const {
            payload: { status, action, data },
          } = params;
          if (status === 'success') {
            loginSuccess({ action, data });

            if (action === 'signup' || action === 'login') {
              const url = `${customRedirect}`;

              if (customRedirect && !url.includes('signout')) {
                const separator = url.indexOf('?') > 0 ? '&' : '?';
                window.location.href = `${url}${separator}auth_provider=oa&nruuid=${encodeURIComponent(
                  getNrUUID()
                )}`;
              } else if (!isIntegrationTestOn()) {
                window.location.href = window.location.origin.includes('local.')
                  ? envUrl
                  : window.location.origin;
              }
            }
          }
          break;
        }
      }
    },
    [customRedirect, envUrl, window]
  );
}
